import axios from 'axios';

export const cbdAPI = axios.create ({
  baseURL: '/',
  timeout: 480000,
});



// WEBPACK FOOTER //
// ./src/data/api.js